import React from 'react';

const ExternalLinksLogoWrapper = ({ children, className, linksName }) => (
  <div className="aridhia-external-links-dropdown">
    {children}
    <span className={className}>
      {` ${linksName}`}
    </span>
  </div>
);

export default ExternalLinksLogoWrapper;
